export default __webpack_public_path__ + "static/media/wap_platform_introduction_pic4.a514757b.png";